export default {
  ERR: '[global] err',

  CATEGORIES: '[global] categories',

  APPEND_COURSE: '[global] append courses',

  REACH_BOTTOM: '[global] reach-bottom-counter add 1',

  SET_LAUNCH_OPTIONS: '[global] set launch options',

  SET_VIP_STATUS: '[global] set vip',

  SET_REDIRECT_FLAG: '[global] order to redirect',

  UNSET_REDIRECT_FLAG: '[global] unset redirect flag'
}
